"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APSelect = require("../../../../common/APSelect");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var BuySellInstrumentSelector = function BuySellInstrumentSelector(_ref) {
  var label = _ref.label,
    baseClasses = _ref.baseClasses,
    instruments = _ref.instruments,
    selectedInstrument = _ref.selectedInstrument,
    onInstrumentSelect = _ref.onInstrumentSelect;
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  (0, _react.useEffect)(function () {
    var preSelectedInstrument = instruments.find(function (i) {
      return i.InstrumentId === selectedInstrument.InstrumentId;
    });
    if (preSelectedInstrument || !instruments.length) return;
    var instrumentId = instruments[0].InstrumentId;
    onInstrumentSelect(instrumentId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('crypto-container')
  }, /*#__PURE__*/_react["default"].createElement(_APSelect.InnerSelect, {
    showTriangles: true,
    name: "instrument",
    label: t(label),
    customClass: baseClasses(),
    onSelect: onInstrumentSelect,
    value: selectedInstrument.InstrumentId,
    options: instruments.map(function (instrument) {
      return {
        value: instrument.InstrumentId,
        label: "".concat(instrument.Product1FullName, " / ").concat(instrument.Product2FullName)
      };
    })
  }));
};
BuySellInstrumentSelector.propTypes = {
  baseClasses: _propTypes["default"].func.isRequired,
  label: _propTypes["default"].string.isRequired,
  onInstrumentSelect: _propTypes["default"].func.isRequired,
  instruments: _propTypes["default"].array.isRequired,
  selectedInstrument: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = BuySellInstrumentSelector;